<template>
  <WhatsHappeningEntriesBox boxItemClass="light" :entries="entries" :tellAttendeeToGoToTheMeeting="false" />
</template>

<script>
import WhatsHappeningEntriesBox from './WhatsHappeningEntriesBox'

export default {
  name: 'WhatsHappeningNextEntries',
  props: ['entries'],
  components: {WhatsHappeningEntriesBox}
}
</script>
